import React from 'react';
import './datePicker.css';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import { Datepicker, Button, Page, setOptions } from '@mobiscroll/react';

setOptions({
    theme: 'ios',
    themeVariant: 'light'
});

function Dates() {
    const [openPicker, setOpenPicker] = React.useState(false);
    const [date, setDate] = React.useState(new Date());
    
    const show = () => {
        setOpenPicker(true);
    };
    
    const onClose = () => {
        setOpenPicker(false);
    };
    
    const inputProps = {
        className: 'md-mobile-picker-input',
        placeholder: 'Please Select...'
    };
    
    const boxInputProps = {
        className: 'md-mobile-picker-box-label',
        inputStyle: 'box',
        placeholder: 'Please Select...'
    };
    
    return (
        <Page className='datePicker'>
            <div className="md-mobile-picker-inline">
                <Datepicker 
                    display="inline" 
                    controls={['date']} 
                    touchUi={true} 
                    dateFormat="DD/MM/YYYY"
                />
            </div>
        </Page>
    ); 
}


export default Dates;